import {
  Component,
  computed,
  EventEmitter,
  inject,
  Inject,
  Output
} from '@angular/core';
import { SimplebarAngularModule } from 'simplebar-angular';
import { Store } from '@ngrx/store';
import { getLayoutMode, getSidebarSize } from '@app/store/layouts/layout-selector';
import { LAYOUT_MODE, SIDEBAR_SIZE } from '@app/store/layouts/layout';
import { changeMode } from '@app/store/layouts/layout-action';
import { CommonModule, DOCUMENT } from '@angular/common';
import { CookieService } from 'ngx-cookie-service';
import { LanguageService } from '@app/core/services/language.service';
import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { Resources } from '@app/resources';
import { AuthService } from '@app/auth/auth.service';
import { TranslatePipe } from '@ngx-translate/core';
import { ModalService } from '@shared/services/modal/modal.service';
import { UsersService } from '@modules/settings/users/users.service';
import { Router, RouterLink } from '@angular/router';
import { LocalStorage } from '@shared/services/storages/local-storage';
import { Languages, languageList } from '@app/core/services/languages.enum';
import { NotificationsComponent } from '@app/layouts/topbar/notifications/notifications.component';
import { environment } from '@environments/environment';
import urlJoin from 'url-join';
import { CompaniesService } from '@modules/universal-billing/companies/companies.service';
import { Company } from '@modules/universal-billing/companies/companies.interfaces';
import { RoleIdLabels, Roles, RolesLabels } from '@common/rbac/roles';
import { NgCanDirective } from '@common/rbac/ng-can.directive';
import { RoleService } from '@common/rbac/role.service';

@Component({
  selector: 'app-topbar',
  standalone: true,
  imports: [
    SimplebarAngularModule,
    NgbDropdownModule,
    CommonModule,
    TranslatePipe,
    NotificationsComponent,
    RouterLink,
    NgCanDirective
  ],
  templateUrl: './topbar.component.html',
  styleUrl: './topbar.component.scss'
})
export class TopbarComponent {
  MODE = LAYOUT_MODE;
  SIDEBAR_SIZE = SIDEBAR_SIZE;
  currantMode!: string;
  sidebarSize!: string;
  element: any;

  selectedItem!: any;
  storeValue: any;
  flagvalue: any;
  valueset: any;
  countryName: any;

  currentCompany: Company | null = null;

  @Output() mobileMenuButtonClicked = new EventEmitter();
  authService: AuthService = inject(AuthService);
  userData = computed(() => this.authService.userData());

  photoThumb = computed(() => {
    if (this.userData() && this.userData()?.photoThumb) {
      return urlJoin(environment.storageUrl, this.userData().photoThumb);
    }
    return null;
  });

  modalService = inject(ModalService);
  service = inject(UsersService);
  listLang = languageList;
  protected readonly Resources = Resources;
  private router = inject(Router);

  constructor(
    private store: Store,
    @Inject(DOCUMENT) private document: any,
    public languageService: LanguageService,
    public _cookiesService: CookieService
  ) {
    this.element = document.documentElement;

    this.store.select(getLayoutMode).subscribe((mode) => {
      this.currantMode = mode;
    });
    this.store.select(getSidebarSize).subscribe((sSize) => {
      this.sidebarSize = sSize;
    });
  }

  ngOnInit(): void {
    // Language init
    this.storeValue = LocalStorage.get('lang');
    const val = this.listLang.filter((x) => x.id === this.storeValue);
    this.countryName = val.map((element) => element.name);
    if (val.length === 0) {
      if (this.flagvalue === undefined) {
        this.valueset = 'assets/images/flags/de.svg';
      }
    } else {
      this.flagvalue = val.map((element) => element.icon);
    }
  }

  modeChange() {
    const mode =
      this.currantMode === this.MODE.LIGHTMODE
        ? this.MODE.DARKMODE
        : this.MODE.LIGHTMODE;
    this.store.dispatch(changeMode({ mode }));
  }

  windowScroll() {
    if (document.body.scrollTop > 100 || document.documentElement.scrollTop > 100) {
      (document.getElementById('back-to-top') as HTMLElement).style.display = 'block';
      document.getElementById('page-topbar')?.classList.add('topbar-shadow');
    } else {
      (document.getElementById('back-to-top') as HTMLElement).style.display = 'none';
      document.getElementById('page-topbar')?.classList.remove('topbar-shadow');
    }
  }

  toggleMobileMenu(event: any) {
    document.querySelector('.hamburger-icon')?.classList.toggle('open');
    event.preventDefault();
    this.mobileMenuButtonClicked.emit();
  }

  fullscreen() {
    document.body.classList.toggle('fullscreen-enable');
    if (
      !document.fullscreenElement &&
      !this.element.mozFullScreenElement &&
      !this.element.webkitFullscreenElement
    ) {
      if (this.element.requestFullscreen) {
        this.element.requestFullscreen();
      } else if (this.element.mozRequestFullScreen) {
        this.element.mozRequestFullScreen();
      } else if (this.element.webkitRequestFullscreen) {
        this.element.webkitRequestFullscreen();
      } else if (this.element.msRequestFullscreen) {
        this.element.msRequestFullscreen();
      }
    } else {
      if (this.document.exitFullscreen) {
        this.document.exitFullscreen();
      } else if (this.document.mozCancelFullScreen) {
        this.document.mozCancelFullScreen();
      } else if (this.document.webkitExitFullscreen) {
        this.document.webkitExitFullscreen();
      } else if (this.document.msExitFullscreen) {
        this.document.msExitFullscreen();
      }
    }
  }

  setLanguage(name: string, lang: string, icon: string) {
    this.countryName = name;
    this.flagvalue = icon;
    this.storeValue = lang;
    this.languageService.setLanguage(lang);
  }

  logout() {
    this.authService.logout();
  }

  changeProfile() {
    this.router.navigate([Resources.Profile]);
  }

  protected readonly RoleIdLabels = RoleIdLabels;
  protected readonly RoleService = RoleService;
  protected readonly RolesLabels = RolesLabels;
}
